<app-form-select [formControl]="formControl"
                 [data]="itemsList$ | async"
                 [required]="required"
                 [readonly]="readonly"
                 [label]="'Surface Type'"></app-form-select>
